import type { MenuProps } from 'antd';
import {
  MediaType,
  type UseQuickVOResult,
} from '@/contexts/chat/scripts/hooks/useQuickVO/types';
import styles from './index.module.scss';

const ScreenOperate = ({
  children,
  stopPublish,
}: {
  children: ReactNode;
  stopPublish: UseQuickVOResult['stopPublish'];
}) => {
  const [activeKey, setActiveKey] = useState('');

  const defaultItems: MenuProps['items'] = useMemo(
    () => [
      {
        key: 'screen',
        label: <div className={styles.menuLabel}>Shared Screen</div>,
        disabled: true,
      },
      {
        type: 'divider',
      },
      // {
      //   key: 'display',
      //   label: <div className={styles.menuLabel}>Display Other Contents</div>,
      // },
      {
        key: 'unShare',
        label: <div className={styles.menuLabel}>Stop Sharing</div>,
      },
    ],
    []
  );

  return (
    <Dropdown
      overlayClassName={styles.dropdownwrapper}
      menu={{
        items: defaultItems,
        activeKey,
        onClick: async (item) => {
          setActiveKey(item.key);
          if (item.key === 'unShare') {
            stopPublish(MediaType.SCREENSHARING_VIDEO);
          }
        },
      }}
      placement="top"
      getPopupContainer={(e) => e.parentElement as HTMLDivElement}
    >
      <div>{children}</div>
    </Dropdown>
  );
};
export default ScreenOperate;
